






























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { User, CrudDialogMode, Role, Branch } from '../utils/types'
import {
  checkIfEmailIsValid,
  checkIfPhoneIsValid,
  checkIfEmailIsAvailable,
  checkIfPhoneIsAvailable
} from '@/utils/helpers'
import { Action, Getter } from 'vuex-class'

@Component
export default class UserCrud extends Vue {
  @Action fetchBranches!: (payload: {limit: number; page: number}) => Promise<void>
  @Getter branches!: Branch[]
  @Prop(String) title!: string
  @Prop(Object) user?: User
  @Prop(Number) mode!: CrudDialogMode
  CrudDialogMode = CrudDialogMode
  id = ''
  businessAddress = ''
  businessBranch = ''
  businessName = ''
  email = ''
  firstName = ''
  lastName = ''
  phone = ''
  role = Role.AUTHENTICATED
  password = ''

  isEmailTaken = false
  isPhoneTaken = false
  showPass = false
  roles = [
    { value: Role.ADMIN, text: 'אדמין' },
    { value: Role.AUTHENTICATED, text: 'משתמש רגיל' },
    { value: Role.EMPLOYER, text: 'מעסיק' },
    { value: Role.GUIDE, text: 'מדריך' }
  ]

  rules = {
    isEmailValid: (value: string) =>
      checkIfEmailIsValid(value) || 'אימייל לא תקין',
    isPhoneValid: (value: string) =>
      checkIfPhoneIsValid(value) || 'מספר טלפון לא תקין',
    min8chars: (value: string) => value.length >= 8 || 'לפחות 8 תווים',
    requiredField: (value: string) => !!value || 'שדה חובה'
  }

  @Watch('user')
  onUserPropChange () {
    this.businessAddress = this.user?.business?.address ?? ''
    this.businessBranch = this.user?.business?.branch?.id ?? ''
    this.businessName = this.user?.business?.name ?? ''
    this.id = this.user?.id ?? ''
    this.email = this.user?.email ?? ''
    this.firstName = this.user?.firstName ?? ''
    this.lastName = this.user?.lastName ?? ''
    this.phone = this.user?.phone ?? ''
    this.role = this.user?.role ?? Role.AUTHENTICATED
    this.password = ''
  }

  mounted () {
    this.onUserPropChange()
    this.fetchBranches({ limit: 100, page: 1 })
  }

  async checkEmailAvailability () {
    const email = this.email || ''
    if (checkIfEmailIsValid(email)) {
      this.isEmailTaken = !(await checkIfEmailIsAvailable(email))
      return
    }
    this.isEmailTaken = false
  }

  async checkPhoneAvailability () {
    const phone = this.phone || ''
    if (checkIfPhoneIsValid(phone)) {
      this.isPhoneTaken = !(await checkIfPhoneIsAvailable(phone))
      return
    }
    this.isPhoneTaken = false
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    this.$emit('submit', {
      id: this.id,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      role: this.role,
      password: this.password || undefined,
      business: this.role === Role.EMPLOYER ? {
        address: this.businessAddress,
        branch: this.businessBranch,
        name: this.businessName,
        businessNumber: this.phone
      } : undefined
    })
  }

  get isFormVisible () {
    return (
      this.mode === CrudDialogMode.CREATE || this.mode === CrudDialogMode.EDIT
    )
  }

  get isEmployer () {
    return this.role === Role.EMPLOYER
  }
}
